import React from 'react'
import styles from './index.module.css'
import type * as CSS from 'csstype'
import { cn, UtilityClassNames } from '@s4l/utility-css'

type PaddingLike =
  | CSS.Property.Padding
  | [CSS.Property.Padding]
  | [CSS.Property.Padding, CSS.Property.Padding]
  | [CSS.Property.Padding, CSS.Property.Padding, CSS.Property.Padding]
interface HSectionProps {
  className?: UtilityClassNames
  children: React.ReactNode
  backgroundColor?: CSS.Property.BackgroundColor
  backgroundImage?: string
  paddingTop?: PaddingLike
  paddingBottom?: PaddingLike
  paddingLeftRight?: PaddingLike
  justify?: CSS.Property.JustifyContent
}

export default function HSection({
  children,
  backgroundColor,
  backgroundImage,
  justify,
  paddingTop,
  paddingBottom,
  paddingLeftRight,
  className,
}: HSectionProps) {
  const pTop = Array.isArray(paddingTop) ? paddingTop : [paddingTop]
  const pBottom = Array.isArray(paddingBottom) ? paddingBottom : [paddingBottom]
  const pInline = Array.isArray(paddingLeftRight) ? paddingLeftRight : [paddingLeftRight]

  const inlineStyles = {
    ...(justify && { justifyContent: justify }),
    ...(backgroundColor && { backgroundColor }),
    ...(backgroundImage && { backgroundImage: `url(${backgroundImage})` }),
    ...(paddingTop && {
      '--hsection-s-padding-block-start': pTop[0],
      '--hsection-m-padding-block-start': pTop[1] ?? pTop[0],
      '--hsection-l-padding-block-start': pTop[2] ?? pTop[1] ?? pTop[0],
    }),
    ...(paddingBottom && {
      '--hsection-s-padding-block-end': pBottom[0],
      '--hsection-m-padding-block-end': pBottom[1] ?? pBottom[0],
      '--hsection-l-padding-block-end': pBottom[2] ?? pBottom[1] ?? pBottom[0],
    }),
    ...(paddingLeftRight && {
      '--hsection-s-padding-inline': pInline[0],
      '--hsection-m-padding-inline': pInline[1] ?? pInline[0],
      '--hsection-l-padding-inline': pInline[2] ?? pInline[1] ?? pInline[0],
    }),
  }
  return (
    <section className={cn(styles.section, className)} style={inlineStyles}>
      <div className={styles.content}>{children}</div>
    </section>
  )
}
